













































































import { Component, Mixins, Prop, Provide, Vue } from 'vue-property-decorator'
import { URLS } from '../../../../../service/constant'
import { ConstantMixin } from '../ConstantMixin'
import { OperationMixin } from '../OperationMixin'

@Component
export default class ImageSample extends Mixins(ConstantMixin, OperationMixin) {
  @Prop() public index!: number

  private value = 0
  private uploadUrl = URLS.UPLOAD_URL
  private uploadData = {
    upload_type: 'samples'
  }

  public handleChange(info) {
    if (info.file.status === 'done') {
      if (info.file.response.success) {
        let { url, title } = info.file.response.data
        this.extraData.pic_data.push({
          pic_name: title,
          sensitive_type: [],
          pic_url: url,
          pic_sample: 1
        })
      } else {
        this.$message.error(info.file.response.error)
      }
    }
  }

  public remove(item) {
    const index = this.extraData.pic_data.indexOf(item)
    this.extraData.pic_data.splice(index, 1)
  }
  // 监听粘贴事件
  public pasteImg(e: any) {
    // 参数定义
    let self = this
    let items = (e.clipboardData || (window as any).clipboardData).items || []
    let file: any = null
    for (let item of items) {
      if (item.type.indexOf('image') !== -1) {
        file = item.getAsFile()
        break
      }
    }
    this.uploadFile(file)
  }
  public onmouseenter() {
    let target: any = this.$refs.atextarea
    target.focus()
  }
  public onmouseleave() {
    let target: any = this.$refs.atextarea
    target.blur()
  }
  public uploadFile(file) {
    let self = this
    let formData = new FormData()
    formData.append('file', file)
    formData.append('upload_type', 'samples')
    let xhr = new XMLHttpRequest()
    xhr.onload = function() {
      try {
        let result = JSON.parse(this.responseText)
        console.log(result)
        if (result.success) {
          let { url, title } = result.data
          self.extraData.pic_data.push({
            pic_name: title,
            sensitive_type: [],
            pic_url: url,
            pic_sample: 1
          })
        } else {
          self.$message.error(result.error)
        }
      } catch (e) {
        console.log(e)
      }
    }

    xhr.open('POST', URLS.UPLOAD_URL, true)
    xhr.send(formData)
  }
}
